import { Phone, Mail, MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";

export const Footer = () => {
    const { t } = useTranslation();
    return (
        <footer
            data-testid="site-footer"
            className="relative bg-stone-950 text-stone-300"
        >
            <div className="mx-auto max-w-7xl px-5 sm:px-8 py-20 md:py-24">
                <div className="grid lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-5">
                        <div className="flex items-center gap-2.5">
                            <span className="inline-flex bg-white rounded-2xl p-5 shadow-lg">
                                <img
                                    src="https://res.cloudinary.com/deq3rnrha/image/upload/v1777362730/57F66F69-6741-41CE-9E1B-06B8AB12B13D_izmfua.png"
                                    alt="TruHeal India"
                                    className="h-28 w-auto"
                                />
                            </span>
                        </div>
                        <p className="mt-6 text-stone-400 max-w-md leading-relaxed">
                            {t("footer.tagline")}
                        </p>
                    </div>

                    <div className="lg:col-span-3">
                        <div className="text-xs uppercase tracking-[0.2em] text-orange-400 font-semibold mb-4">
                            {t("footer.explore")}
                        </div>
                        <ul className="space-y-3 text-sm">
                            <li><a href="#process" className="hover:text-white">{t("footer.our_process")}</a></li>
                            <li><a href="#specialities" className="hover:text-white">{t("footer.specialities")}</a></li>
                            <li><a href="#doctors" className="hover:text-white">{t("footer.doctors")}</a></li>
                            <li><a href="#hospitals" className="hover:text-white">{t("footer.hospitals")}</a></li>
                            <li><a href="#testimonials" className="hover:text-white">{t("footer.patient_stories")}</a></li>
                        </ul>
                    </div>

                    <div className="lg:col-span-4">
                        <div className="text-xs uppercase tracking-[0.2em] text-orange-400 font-semibold mb-4">
                            {t("footer.reach")}
                        </div>
                        <ul className="space-y-4 text-sm">
                            <li className="flex items-start gap-3">
                                <Phone className="h-4 w-4 mt-0.5 text-orange-400" />
                                <span dir="ltr">+91 79829 59943 {t("footer.helpline_suffix")}</span>
                            </li>
                            <li className="flex items-start gap-3">
                                <Mail className="h-4 w-4 mt-0.5 text-orange-400" />
                                <span dir="ltr">support@truhealindia.com</span>
                            </li>
                            <li className="flex items-start gap-3">
                                <MapPin className="h-4 w-4 mt-0.5 text-orange-400" />
                                <span>{t("enquiry.office_value")}</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-stone-500">
                    <div>
                        {t("footer.rights", { year: new Date().getFullYear() })}
                    </div>
                    <div className="flex gap-6">
                        <a href="#" className="hover:text-white">{t("footer.privacy")}</a>
                        <a href="#" className="hover:text-white">{t("footer.terms")}</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};
